module.exports = __webpack_public_path__ + "static/SquareSerif-Medium-webfont-ca98ca5c9d44591792af373f296a0f14.woff";